export const LOG_ITEM_NAME = "logs";

export const GENERIC_NAME = "General";

export const AUTHENTICATION_NAME = "Authentication";

export const FIRESTORE_NAME = "Firestore";

export const STORAGE_NAME = "Cloud Storage";

export const FUNCTION_NAME = "Cloud Function";

export const RESULT_SUCCESS = "success";

export const RESULT_ERROR = "error";